import { Injectable, Inject, PLATFORM_ID, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export type AppLang = 'ar' | 'en';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly isBrowser: boolean;
  private readonly _lang = signal<AppLang>('ar');
  lang = this._lang.asReadonly();

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);

    if (this.isBrowser) {
      const saved = (localStorage.getItem('lang') as AppLang) || 'ar';
      this._lang.set(saved);
      this.applyDir(saved);
    }
  }

  setLang(lang: AppLang) {
    this._lang.set(lang);

    if (this.isBrowser) {
      localStorage.setItem('lang', lang);
      this.applyDir(lang);
    }
  }

  getLang(): AppLang {
    return this._lang();
  }

  private applyDir(lang: AppLang) {
    if (!this.isBrowser) return;
    document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', lang);
  }
}
